module.exports = __webpack_public_path__ + "img/v.b4decb5c.jpg";